import { useContext } from 'react';
import { ColorModeContext } from '../../../layouts/context/ColorMode';
import { createChartTheme } from './createChartTheme';

export const useCreateChartTheme = (options = {}) => {
  const { mode } = useContext(ColorModeContext);

  const chartTheme = createChartTheme(mode, {
    ...options,
  });

  return { chartTheme };
};
